import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import formatDate from "../../common/Formatdate";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
  Modal,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import commonapihandler from "../../common/commonapihandler";
import { getHubName } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import user from "../../assets/user.gif";
import { gridHeaderFilteringEnabledSelector } from "@mui/x-data-grid";
import EditPeakSeasonDrawer from "./EditPeakSeasonDrawer";

const imagestyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  width: "90%",
  maxWidth: 900,
  maxHeight: "90vh",
  overflowY: "auto",

  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
};

const Peakseasondashboard = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));
  let token = localStorage.getItem("token");
  let rentalTypeDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.rentalTypes;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const [form, setForm] = useState({
    name: "",
    peakRentalCharges: "",
    startDate: null,
    endDate: null,
    cityId: "",
    isActive: true,
    isPriceDrop: null,
    forRentalType : null
  });
  const [peakSeasonsData, setPeakSeasonsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectionRange, setSelectionRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });
  const [cityname, setCity] = useState(null);
  const [error, setError] = useState("");
  const [systemUserData, setSystemUserData] = useState([]);

  useEffect(() => {
    getAllPeakSeasonData(0);
  }, [cityname]);

  const handleModalClose = () => {
    setSelectedRow(null);
    setForm({
      name: "",
      peakRentalCharges: "",
      startDate: null,
      endDate: null,
      cityId: "",
      isActive: true,
      isPriceDrop: null,
      forRentalType : null
    });
    setOpenModal(false);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  function createData(
    id,
    forRentalType,
    name,
    isPriceDrop,
    active,
    createdAt,
    updatedAt,
    createdBy,
    updatedBy,
    startdate,
    enddate,
    city,
    rentalcharges,
    // amount
    action,
    raw,
  ) {
    return {
      id,
      forRentalType,
      name,
      isPriceDrop,
      active,
      createdAt,
      updatedAt,
      createdBy,
      updatedBy,
      startdate,
      enddate,
      city,
      rentalcharges,
      action,
      raw,
    };
  }
  

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "left" },
    { id: "forRentalType", label: "Rental Type", minWidth: 200, align: "left" },
    { id: "name", label: "Name", minWidth: 150, align: "left" },
    { id: "startdate", label: "Start Date", minWidth: 200, align: "right" },
    { id: "enddate", label: "End Date", minWidth: 200, align: "right" },
    { id: "city", label: "City", minWidth: 100, align: "right" },
    { id: "isPriceDrop", label: "Price Status", minWidth: 150, align: "left" },
    {
      id: "rentalcharges",
      label: "Rental Charges ( % )",
      minWidth: 200,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    { id: "createdAt", label: "Created At", minWidth: 200, align: "right" },
    { id: "updatedAt", label: "Updated At", minWidth: 200, align: "right" },
    { id: "createdBy", label: "Created By", minWidth: 200, align: "right" },
    { id: "updatedBy", label: "Updated By", minWidth: 200, align: "right" },
    { id: "active", label: "Active", minWidth: 70, align: "left" },
    { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  function formatDateForApi(date) {
    if (!date) return ""; // or undefined
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formatStartDate = selectionRange?.startDate
    ? formatDateForApi(selectionRange.startDate)
    : "";

  const formatEndDate = selectionRange?.endDate
    ? formatDateForApi(selectionRange.endDate)
    : "";

  const getAllPeakSeasonData = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = customPage * customRowsPerPage;
    let query = `limit=${customRowsPerPage}&offset=${offset}`;

    if (cityname) {
      query += `&cityId=${cityname}`;
    }

    try {
      const response = await fetch(`${apiUrl}/api/peakseasons?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setPeakSeasonsData(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const formatLocalISO = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const handleDateChange = (field, value) => {
    if (!value) return;

    const date = new Date(value); // from <input type="date">
    if (field === "startDate") date.setHours(0, 0, 0, 0);
    if (field === "endDate") date.setHours(23, 59, 0, 0);

    setForm((prev) => ({
      ...prev,
      [field]: formatLocalISO(date), // <-- local datetime, no UTC shift
    }));
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getAllPeakSeasonData();
  }, []);

  useEffect(() => {
    getCityNames();
  }, []);

  const rows =
    peakSeasonsData?.map((item) =>
      createData(
        item?.id,
        rentalTypeDuplicate[item?.forRentalType] || "-",
        item?.name,
        item?.isPriceDrop === true ? "Decreased" : "Increased",
        item?.isActive ? "True" : "False",
        formatDateAndTime(item?.createdAt),
        formatDateAndTime(item?.updatedAt),
        item?.createdBy
          ? systemUserData.find((user) => user?.id === item?.createdBy)?.name
          : "-",
        item?.updatedBy
          ? systemUserData.find((user) => user?.id === item?.updatedBy)?.name
          : "-",
        formatDateAndTime(item?.startDate),
        formatDateAndTime(item?.endDate),
        cities[item?.cityId],
        item?.peakRentalCharges,
        "Edit",
        item,
      ),
    ) || [];

  const handleEditClick = (row) => {
    const raw = row.raw;
    setSelectedRow(raw);

    setForm({
      name: raw?.name || "",
      peakRentalCharges: raw?.peakRentalCharges || "",
      startDate: row.startdate ? new Date(row.startdate).toISOString() : null,
      endDate: row.enddate ? new Date(row.enddate).toISOString() : null,
      cityId: raw?.cityId || "",
      isActive: !!raw?.isActive,
      isPriceDrop: !!raw?.isPriceDrop,
      forRentalType : !!raw?.forRentalType ? raw?.forRentalType : null
    });

    setOpenModal(true);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getAllPeakSeasonData(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllPeakSeasonData(newPage, rowsPerPage);
  };

  useEffect(() => {
    getSystemUser();
  }, []);

  const getSystemUser = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=${1}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setSystemUserData(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const EditPeakSeasonDetailsAPI = async () => {
    if (
      !form.name ||
      !form.peakRentalCharges ||
      !form.startDate ||
      !form.endDate ||
      !form.cityId || !form.forRentalType
    ) {
      return setError("Please fill all the details");
    }

    const payload = {
      id: selectedRow.id,
      name: form.name,
      isActive: form.isActive,
      startDate: form.startDate,
      endDate: form.endDate,
      cityId: form.cityId,
      peakRentalCharges: form.peakRentalCharges,
      isPriceDrop: form?.isPriceDrop,
      forRentalType : form?.forRentalType
    };
    try {
      const response = await fetch(`${apiUrl}/api/peakseasons`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getAllPeakSeasonData();
        setForm({
          name: "",
          peakRentalCharges: "",
          startDate: null,
          endDate: null,
          cityId: "",
          isActive: true,
          forRentalType : null,
        });
        setOpenModal(false);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }

    // send to API here
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
  };

  return (
    <div>
      {openModal && (
        <EditPeakSeasonDrawer
          openModal={openModal}
          handleModalClose={handleModalClose}
          selectedRow={selectedRow}
          form={form}
          handleChange={handleChange}
          handleDateChange={handleDateChange}
          EditPeakSeasonDetails={EditPeakSeasonDetailsAPI}
          cities={cities}
          error={error}
        />
      )}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-4 mt-6">
          <img className="w-20 h-20 rounded-full" src={user} alt="User" />
          <h1 className="text-2xl font-bold">Welcome back, {profile?.name}!</h1>
        </div>
      </div>

      <Box
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          lg: "repeat(7, 1fr)",
        }}
        gap={2}
        mb={3}
      >
        <h1 className="mt-2">Filter By :</h1>

        {/* Date Range Picker */}
        {/* <Paper elevation={3} sx={{ p: 1.5, borderRadius: 2 }}> */}
        {/* <DaterangePicker
          selectionRange={selectionRange || {}}
          setSelectionRange={setSelectionRange}
        /> */}
        {/* </Paper> */}

        <FormControl fullWidth size="small">
          <InputLabel id="city-select-label">City</InputLabel>
          <Select
            labelId="city-select-label"
            id="city-select"
            value={cityname}
            onChange={handleCityChange}
          >
            {cities &&
              Object.entries(cities).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>

      <div className="w-full sm:w-auto flex justify-end sm:ml-auto gap-4 mt-16 sm:mt-0">
        {/* <button
          onClick={() => {
            setPage(0);
            getAllPeakSeasonData(0);
          }}
          className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
        >
          Search
        </button> */}
        <button
          onClick={() => {
            setCity(null);
            // getAllPeakSeasonData(0);
          }}
          className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
        >
          Reset
        </button>
      </div>

      <Paper
        sx={{
          // width: "80%",
          boxShadow: 6,
          borderRadius: 2,
          mt: 4,
        }}
      >
        <TableContainer
          sx={{
            // maxHeight: 500,
            overflowX: "scroll", // ✅ horizontal scroll only if needed
          }}
        >
          <Table stickyHeader aria-label="bookings table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#f8f7f6ff",
                      fontWeight: 300,
                    }}
                    key={column.id}
                    align={column.align || "left"}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <div className="flex flex-col items-center h-40 justify-center">
                      <BlinkBlur
                        color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ) : rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <h1 className="mt-10 text-lg font-bold">No Data Found</h1>
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row, idx) => (
                  <TableRow hover key={idx}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          sx={{
                            ...(column.id === "inquiryaging"
                              ? {
                                  color: "#fc7070ff",
                                  fontWeight: 900,
                                }
                              : {}),
                            ...(column.id === "active"
                              ? {
                                  color:
                                    value === "True"
                                      ? "#0bf80bff"
                                      : "#f3280eff",
                                  fontWeight: 900,
                                }
                              : {}),
                          }}
                          //   onClick={() => handleViewClick(row)}
                          key={column.id}
                          align={column.align}
                        >
                          {column.id === "action" ? (
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleEditClick(row)}
                            >
                              Edit
                            </Button>
                          ) : (
                            value || "-"
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[20, 30, 40]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".MuiTablePagination-toolbar": {
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
            },
          }}
        />
      </Paper>
    </div>
  );
};

export default Peakseasondashboard;
